import { format } from 'date-fns';

import styles from './user-active-sub-info.module.scss';

type Props = {
    subscription: any;
};

const UserActiveSubInfo = ({ subscription }: Props) => {
    return (
        <div className={styles.activeSubSection}>
            <p>
                Suscripción <span className={styles.active}>activa</span>
            </p>
            <p>Plan: {subscription.service.name}</p>
            <p>
                Vencimiento:{' '}
                {format(new Date(subscription.expiresAt), 'MMM dd, yyyy')}
            </p>
        </div>
    );
};

export { UserActiveSubInfo };
